import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  aspect-ratio: 4 / 1;
  display: flex;
  overflow: hidden;
  position: relative;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ChangeImageButton = styled.label`
  background-color: #ccc;
  color: #000;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 0.25rem;
  padding: 0.25rem 1rem;
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  opacity: 0.3;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;

export const NoImageContainer = styled.div`
  color: #f2f2f2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
`;

export const NoImageText = styled.p`
  font-size: 1rem;
  text-align: center;
  max-width: 23rem;
`;